import {createContext} from 'react'

export const AnalyticsDetailsContext = createContext({
  summary: {} as any,
  PriceReportData: null,
  PriceReportMeta: {} as any,
  customerOverviewData: {} as any,
  overviewData: {} as any,
  ProductPerformanceData: {} as any,
  productSales: {} as any,
  SKUData: null,
  SKUMeta: {} as any,
  TopCustomerData: null,
  MainProductData: null,
  MainProductMeta: {} as any,
  TopCustomerMeta: {} as any,
  AllStateData: null,
  AllStateCount: null,
  avgPrice: null,
  filters: {} as any,
  setFilters: (filters: any) => {},
  onDateChange: (start: any, end: any) => {},
  onPeriodChange: (period: any) => {},
  isLoading: false,
  options: [] as any,
  chartType: '' as any,
  setChartType: (type: string) => {},
  dateRangeLable: '',
  setDateRangeLable: (dateRangeLable: string) => {},
  pieChartData: {} as any,
  distributionData: {} as any,
  topSku: null,
  topCustomer: null,
  topState: null,
  product_sales: [] as any,
  dateRange: {} as any,
  setDateRange: (dateRange: any) => {},
  onTopCustomerStateChange: (state: string) => {},
  onSkuReportStateChange: (state: string) => {},
})

export const OrderHistoryPageContext = createContext({
  orderHistoryData: [],
  isLoading: false,
  orderFilters: {},
  onSortingChange: (key: string, value: string) => {},
})

export const PriceChangeLogPageContext = createContext({
  PriceChangeLogData: [],
  isLoading: false,
  priceChangeLogFilters: {},
  onSortingChange: (key: string, value: string) => {},
})

export const ReplenishmentReportPageContext = createContext({
  hasWritePermission: false,
  replenishmentReportList: [] as any,
  isLoading: false,
  filters: {},
  onSortingChange: (field: string, direction: 'asc' | 'desc') => {},
  meta: {} as any,
})